module.exports = __webpack_public_path__ + "static/media/budgety.576c08fe.png";